import React from 'react'

import { FormControl } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'
import DatePicker from 'react-16-bootstrap-date-picker'


const MetadataOverviewField = (props) => {

  const {
    metadata,
    editableText,
    editableArray,
    _renderMenuItemChildren,
  } = props

  if (metadata.type.toLowerCase() === 'selectable options') {
    const sortedMetadataOptions = metadata.metadata_values.sort((a, b) => {
      return a.option.localeCompare(b.option)
    })

    return (
      <Typeahead
        id={metadata.name}
        multiple
        labelKey="option"
        options={sortedMetadataOptions}
        selected={editableArray}
        onChange={props.handleEditableArrayChange}
      />
    )
  } else if (metadata.type.toLowerCase() === 'number') {
    return (
      <FormControl
        type='number'
        value={editableText}
        onChange={props.handleChange}
      />
    )
  } else if (metadata.type.toLowerCase() === 'date') {
    let datePickerValue = null
    if (editableText) {
      datePickerValue = props.generateFormattedDate(editableText)
    }
    return (
      <DatePicker
        value={datePickerValue}
        dateFormat="MM-DD-YYYY"
        weekStartsOn={1}
        style={{width: "120px", paddingBottom: "5px", display: "inline-block"}}
        onChange={props.handleDateChange}
      />
    )
  } else if (metadata.type.toLowerCase() === 'user') {
    const sortedMetadataOptions = metadata.metadata_values.sort((a, b) => {
      return a.user.first_name.localeCompare(b.user.first_name)
    })
    return (
      <Typeahead
        id={metadata.name}
        multiple
        labelKey={(option) => `${option.user.first_name} ${option.user.last_name}`}
        renderMenuItemChildren={(option, props, index) => _renderMenuItemChildren(option.user, props, index)}
        options={sortedMetadataOptions}
        selected={editableArray}
        onChange={props.handleEditableArrayChange}
      />
    )
  } else if (metadata.type.toLowerCase() === 'text') {
    return (
      <FormControl
        componentClass="textarea"
        className="overview-input-field"
        value={editableText}
        onChange={props.handleChange}
      />
    )
  } else {
    return null
  }
}

export default MetadataOverviewField



// WEBPACK FOOTER //
// ./src/routes/projects_project/components/MetadataOverviewField.js